<div class="dashboard-container">
  <header class="dashboard-header">
    <div class="header-main">
      <div class="header-greeting">
        <h1 class="greeting-title">{{ getGreeting() }}, {{ getCurrentUser()?.name || 'Usuario' }}</h1>
        <p class="greeting-date">{{ getCurrentDateFormatted() }}</p>
      </div>
      <span class="role-badge">{{ getRoleLabel(getCurrentUser()?.role || '') }}</span>
    </div>
    <div class="header-meta">
      <span class="last-updated" *ngIf="lastUpdated" title="Última actualización">
        <i class="fas fa-clock"></i> {{ formatDate(lastUpdated) }}
      </span>
      <button type="button" class="btn-refresh" (click)="loadDashboardData()" title="Actualizar datos">
        <i class="fas fa-sync-alt"></i> Actualizar
      </button>
    </div>
  </header>

  <!-- Resumen del día (visible según permiso dashboard_ver_resumen) -->
  <section class="dashboard-section" *ngIf="hasPermiso('dashboard_ver_resumen')">
    <h2 class="section-title"><i class="fas fa-chart-pie"></i> Resumen del día</h2>
    <div class="stats-grid">
      <div class="stat-card stat-tables" *ngIf="hasPermiso('mesas_ver')">
        <div class="stat-icon"><i class="fas fa-chair"></i></div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.totalTables }}</span>
          <span class="stat-label">Total Mesas</span>
          <div class="stat-detail">
            <span class="detail-available">{{ stats.availableTables }} disponibles</span>
            <span class="detail-occupied">{{ stats.occupiedTables }} ocupadas</span>
          </div>
        </div>
      </div>
      <div class="stat-card stat-orders" *ngIf="hasPermiso('pedidos_ver')">
        <div class="stat-icon"><i class="fas fa-clipboard-list"></i></div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.activeOrders }}</span>
          <span class="stat-label">Órdenes Activas</span>
          <div class="stat-detail">
            <span class="detail-pending">{{ stats.pendingOrders }} pendientes</span>
          </div>
        </div>
      </div>
      <div class="stat-card stat-revenue" *ngIf="hasPermiso('dashboard_ver_ingresos')">
        <div class="stat-icon"><i class="fas fa-wallet"></i></div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.todayRevenue | currencyCop }}</span>
          <span class="stat-label">Ingresos Hoy</span>
          <div class="stat-detail">
            <span>{{ stats.todayBills }} facturas</span>
          </div>
        </div>
      </div>
      <div class="stat-card stat-ticket" *ngIf="hasPermiso('dashboard_ver_ingresos')">
        <div class="stat-icon"><i class="fas fa-receipt"></i></div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.averageTicket | currencyCop }}</span>
          <span class="stat-label">Ticket Promedio</span>
          <div class="stat-detail"><span>Hoy</span></div>
        </div>
      </div>
    </div>
  </section>

  <!-- Gráficas (visible según permiso dashboard_ver_graficas) -->
  <section class="dashboard-section charts-section" *ngIf="hasPermiso('dashboard_ver_graficas')">
    <h2 class="section-title"><i class="fas fa-chart-line"></i> Gráficas</h2>
    <div class="charts-grid">
      <!-- Pedidos por estado (donut) -->
      <div class="chart-card" *ngIf="hasPermiso('pedidos_ver')">
        <h3 class="chart-title"><i class="fas fa-tasks"></i> Pedidos por estado</h3>
        <div class="chart-body chart-donut-wrap">
          <div class="chart-donut" *ngIf="ordersByStatus.length > 0" [style.background]="getDonutConic(ordersByStatus)"></div>
          <div class="chart-donut chart-donut-empty" *ngIf="ordersByStatus.length === 0">
            <span>Sin datos</span>
          </div>
          <div class="chart-donut-legend" *ngIf="ordersByStatus.length > 0">
            <div *ngFor="let seg of ordersByStatus" class="legend-item">
              <span class="legend-dot" [style.background]="seg.color"></span>
              <span class="legend-label">{{ seg.label }}</span>
              <span class="legend-value">{{ seg.count }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Ocupación de mesas (donut) -->
      <div class="chart-card" *ngIf="hasPermiso('mesas_ver')">
        <h3 class="chart-title"><i class="fas fa-chair"></i> Ocupación de mesas</h3>
        <div class="chart-body chart-donut-wrap">
          <div class="chart-donut chart-donut-small" [style.background]="getTablesConic()"></div>
          <div class="chart-donut-legend chart-legend-inline">
            <div class="legend-item">
              <span class="legend-dot detail-available"></span>
              <span>Disponibles: {{ stats.availableTables }}</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot detail-occupied"></span>
              <span>Ocupadas: {{ stats.occupiedTables }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Productos más vendidos (barras horizontales) -->
      <div class="chart-card chart-card-wide" *ngIf="hasPermiso('menu_ver')">
        <h3 class="chart-title"><i class="fas fa-trophy"></i> Productos más vendidos</h3>
        <div class="chart-body chart-bars-h">
          <div *ngIf="topProducts.length === 0" class="chart-empty">No hay datos de ventas</div>
          <div *ngFor="let p of topProducts" class="bar-row">
            <span class="bar-label">{{ p.name }}</span>
            <div class="bar-track">
              <div class="bar-fill" [style.width.%]="maxProductCount ? (p.count / maxProductCount) * 100 : 0"></div>
            </div>
            <span class="bar-value">{{ p.count }}</span>
          </div>
        </div>
      </div>

      <!-- Ingresos últimos 7 días (barras verticales) -->
      <div class="chart-card chart-card-wide" *ngIf="hasPermiso('dashboard_ver_ingresos')">
        <h3 class="chart-title"><i class="fas fa-wallet"></i> Ingresos últimos 7 días</h3>
        <div class="chart-body chart-bars-v">
          <div *ngFor="let d of revenueByDay" class="bar-v-wrap" [title]="d.label + ': ' + (d.total | currencyCop)">
            <div class="bar-v-track">
              <div class="bar-v-fill" [style.height.%]="maxRevenueDay ? (d.total / maxRevenueDay) * 100 : 0"></div>
            </div>
            <span class="bar-v-label">{{ d.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contenido Principal -->
  <section class="dashboard-section dashboard-content">
    <div class="content-card content-orders" *ngIf="hasPermiso('pedidos_ver')">
      <div class="card-header">
        <h2><i class="fas fa-clock"></i> Órdenes Recientes</h2>
        <button type="button" class="btn-link" (click)="navigateTo('/orders')">
          Ver todas <i class="fas fa-arrow-right"></i>
        </button>
      </div>
      <div class="orders-list">
        <div *ngIf="recentOrders.length === 0" class="empty-state">
          <i class="fas fa-inbox"></i>
          <p>No hay órdenes activas</p>
          <button type="button" class="btn-empty-action" (click)="navigateTo('/orders')">Ir a Pedidos</button>
        </div>
        <div *ngFor="let order of recentOrders" class="order-item" (click)="navigateTo('/orders')">
          <div class="order-info">
            <span class="order-id">Orden #{{ order.id.slice(-6) }}</span>
            <span class="order-time">{{ formatDate(order.createdAt) }}</span>
          </div>
          <div class="order-status">
            <span [class]="'status-badge status-' + getOrderStatusClass(order.status)">
              {{ getOrderStatusLabel(order.status) }}
            </span>
          </div>
          <div class="order-items">{{ order.items.length }} item(s) · {{ order.totalAmount | currencyCop }}</div>
        </div>
      </div>
    </div>

    <div class="content-card content-products" *ngIf="hasPermiso('menu_ver')">
      <div class="card-header">
        <h2><i class="fas fa-trophy"></i> Más Vendidos</h2>
        <button type="button" class="btn-link" (click)="navigateTo('/menu')">
          Ver menú <i class="fas fa-arrow-right"></i>
        </button>
      </div>
      <div class="products-list">
        <div *ngIf="topProducts.length === 0" class="empty-state">
          <i class="fas fa-chart-bar"></i>
          <p>No hay datos de ventas aún</p>
          <button type="button" class="btn-empty-action" (click)="navigateTo('/menu')">Ver Menú</button>
        </div>
        <div *ngFor="let product of topProducts; let i = index" class="product-item">
          <span class="product-rank" [class.rank-top]="i < 3">{{ i + 1 }}</span>
          <div class="product-info">
            <span class="product-name">{{ product.name }}</span>
            <span class="product-stats">{{ product.count }} vendidos</span>
          </div>
          <span class="product-revenue">{{ product.revenue | currencyCop }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Accesos Rápidos -->
  <section class="dashboard-section quick-actions">
    <h2 class="section-title"><i class="fas fa-bolt"></i> Accesos Rápidos</h2>
    <div class="actions-grid">
      <button *ngIf="canShowRoute('/floor-plan')" type="button" class="action-btn" (click)="navigateTo('/floor-plan')">
        <i class="fas fa-map"></i>
        <span>Mesas</span>
      </button>
      <button *ngIf="canShowRoute('/orders')" type="button" class="action-btn" (click)="navigateTo('/orders')">
        <i class="fas fa-clipboard-list"></i>
        <span>Pedidos</span>
      </button>
      <button *ngIf="canShowRoute('/kitchen')" type="button" class="action-btn" (click)="navigateTo('/kitchen')">
        <i class="fas fa-fire"></i>
        <span>Cocina</span>
      </button>
      <button *ngIf="canShowRoute('/billing')" type="button" class="action-btn" (click)="navigateTo('/billing')">
        <i class="fas fa-cash-register"></i>
        <span>Facturación</span>
      </button>
      <button *ngIf="canShowRoute('/reports')" type="button" class="action-btn" (click)="navigateTo('/reports')">
        <i class="fas fa-chart-bar"></i>
        <span>Reportes</span>
      </button>
      <button *ngIf="canShowRoute('/menu')" type="button" class="action-btn" (click)="navigateTo('/menu')">
        <i class="fas fa-utensils"></i>
        <span>Menú</span>
      </button>
      <button *ngIf="canShowRoute('/insumos')" type="button" class="action-btn" (click)="navigateTo('/insumos')">
        <i class="fas fa-boxes"></i>
        <span>Insumos</span>
      </button>
    </div>
  </section>
</div>
